import * as BizCharts from 'bizcharts';
import React, { FC } from 'react';
import './chartTheme';
import { withNiceScale } from './chartUtils';

const { Chart, Axis, Geom, Tooltip } = BizCharts;

interface LineChartProps {
	cols: any;
	height: number;
	data: any;
	fillArea: boolean;
	position: string;
	chartPadding?: [number, number, number, number];
	color?: string;
	xAxisName: string;
	yAxisName: string;
	xAxisLabel?: any;
	yAxisLabel?: any;
	tooltipTemplate?: any;
	baselineValue: number;
	baselineText: string;
}

export const KPILineChart: FC<LineChartProps> = ({
	chartPadding,
	tooltipTemplate,
	baselineValue,
	baselineText,
	data,
	cols,
	color,
	height,
	fillArea,
	xAxisName,
	yAxisName,
	xAxisLabel,
	yAxisLabel,
	position,
}) => {
	const lineColor = color || '#18a1cd';
	return (
		<Chart
			height={height}
			padding="auto"
			data={data}
			scale={withNiceScale(cols)}
			autoFit={true}
			theme="openwrench"
		>
			<Axis name={xAxisName} label={xAxisLabel} />
			<Axis name={yAxisName} label={yAxisLabel} />
			<Tooltip
				crosshairs={{ type: 'y' }}
				itemTpl={
					tooltipTemplate
						? tooltipTemplate
						: `
                    <li data-index={index}>
                        <!-- The marker for each record -->
                        <span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>
                        {name}: {value}
                    </li>
                `
				}
			/>
			<Geom type="line" position={position} color={lineColor} size={2} />
			{fillArea ? <Geom type="area" position={position} color={lineColor} /> : null}
			<Geom
				type="point"
				position={position}
				color={lineColor}
				size={4}
				shape={'circle'}
				style={{ stroke: '#fff', lineWidth: 1 }}
			/>
		</Chart>
	);
};
